import { useEffect, useState } from 'react';

const STORAGE_KEY = 'wmzm-age-confirmed';

export default function AgeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      setOpen(window.localStorage.getItem(STORAGE_KEY) !== '1');
    } catch {
      setOpen(true);
    }
  }, []);

  const confirm = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore storage errors
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-primary-950/80 px-4 backdrop-blur-sm">
      <div className="w-full max-w-[480px] animate-fade-up rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
        <div className="flex items-center gap-3">
          <span className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-accent-500 bg-accent-50">
            <span className="font-heading text-base font-semibold text-accent-700">18+</span>
          </span>
          <div>
            <h2 className="font-heading text-lg font-semibold text-foreground-950">年龄确认</h2>
            <p className="text-xs text-foreground-500">Adult content notice</p>
          </div>
        </div>

        <p className="mt-5 text-[13px] leading-7 text-foreground-700">
          本网站面向成年人提供影视内容的分类浏览演示，包含成人向题材。请确认您已年满
          <strong className="mx-1 font-medium text-foreground-950">18 周岁</strong>
          且所在地区允许浏览此类内容，再继续访问。
        </p>
        <p className="mt-3 text-[13px] leading-7 text-foreground-700">
          站内全部条目、封面与简介均为虚构示范数据，播放区域仅为界面演示，不提供真实播放资源与下载入口。
        </p>

        <div className="mt-6 flex flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={confirm}
            className="flex h-11 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-check-line text-base" />
            </span>
            我已年满 18 岁，进入网站
          </button>
          <a
            href="https://www.google.com"
            rel="nofollow noopener"
            className="flex h-11 w-full cursor-pointer items-center justify-center whitespace-nowrap rounded-md border border-background-300 px-5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
          >
            我未满 18 岁
          </a>
        </div>

        <p className="mt-4 text-[11px] leading-5 text-foreground-400">
          继续访问即表示您同意本站的使用条款与免责声明。所有内容不构成任何形式的推荐或销售。
        </p>
      </div>
    </div>
  );
}